import './ProjectPage.css';
import { useEffect, useRef } from 'react';
import { CurrentProjectScreen } from './ProjectSreens/CurrentProjectScreen';
import { useGetAllProjectsQuery } from 'src/services';
import { useParams } from 'react-router-dom';
import { useTheme } from 'src/provider/ThemeProvider';

const ProjectPage = () => {
  const splideRef = useRef(null);
  const { id } = useParams();
  const { data: projectsData } = useGetAllProjectsQuery();
  const { setTheme } = useTheme();

  useEffect(() => {
    if (projectsData && splideRef.current?.splide.index !== 1) {
      splideRef.current?.splide.go(1);
    }
  }, [projectsData, id]);

  useEffect(() => {
    if (splideRef.current) {
      splideRef.current?.splide.on('move', function () {
        window.scrollTo(0, 0);
      });
    }
  }, [splideRef]);

  useEffect(() => {
    setTheme('blue');
  }, []);

  return <CurrentProjectScreen />;
};

export default ProjectPage;
